import React from 'react';
import Login from '../components/Auth/Login';
import styled from 'styled-components';

const LoginPageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const LoginPage: React.FC = () => {
  return (
    <LoginPageContainer>
      <Login />
    </LoginPageContainer>
  );
};

export default LoginPage;
